import { render, staticRenderFns } from "./StadiumAdminSettingCreateAndUpdateFormItems.vue?vue&type=template&id=340645a8&"
import script from "./StadiumAdminSettingCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./StadiumAdminSettingCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports